<template>
  <!-- Kept in its own component so typing in the form doesn't re-render the whole staff list -->
  <el-dialog
    title="Add new member staff"
    :modal-append-to-body="true"
    :visible="value"
    width="760px"
    custom-class="newUserForm"
    @update:visible="$emit('input', $event)"
    @close="resetFormNewUser"
  >
    <div class="edit-user">
      <form>
        <div class="field">
          <span class="label">First name:</span>
          <el-input v-model="newUser.firstName" placeholder="John" data-test-id="studioAdminAddUserFirstNameInput"></el-input>
        </div>
        <div class="field">
          <span class="label">Last name:</span>
          <el-input v-model="newUser.lastName" placeholder="Doe" data-test-id="studioAdminAddUserLastNameInput"></el-input>
        </div>
        <div class="field">
          <span class="label">Email:</span>
          <el-input v-model="newUser.email" placeholder="Doe" data-test-id="studioAdminAddUserEmailInput"></el-input>
        </div>
        <div class="field">
          <span class="label">Position:</span>
          <el-select v-model="newUser.userRole" filterable data-test-id="studioAdminAddUserRoleInputWrapper">
            <el-option
              v-for="item in roles"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              data-test-id="studioAdminAddUserRoleOption"
            ></el-option>
          </el-select>
        </div>
        <div class="field">
          <span class="label">Manage permissions:</span>
          <el-radio-group v-model="newUser.accessId" data-test-id="studioAdminAddUserPermissionRadioWrapper">
            <el-radio-button
              v-for="item in permissions"
              :key="item.value"
              :label="item.value"
              :disabled="item.value < myStudioAccess"
              data-test-id="studioAdminAddUserPermissionRadioOption"
            >
              <el-tooltip
                v-if="item.value < myStudioAccess"
                class="item"
                effect="dark"
                placement="top">
                <span slot="content">You don't have the possibility <br/>to give this permission.</span>{{
                  item.label
                }}
                <span>{{ item.label }}</span>
              </el-tooltip>
              <span v-else>{{ item.label }}</span>
            </el-radio-button>
          </el-radio-group>
        </div>
        <el-alert
          v-if="errorMessage !== ''"
          :title="errorMessage"
          type="error"
          :closable="true"
          show-icon
        ></el-alert>
      </form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button data-test-id="studioAdminAddUserCancelButton" @click="$emit('input', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :disabled="!!!canUpdateUser"
        :loading="loadingUserCreate"
        data-test-id="studioAdminAddUserSaveButton"
        @click="saveNewUser(newUser)">
        Save
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'AddStaffMemberDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    studioId: {
      type: String,
      required: true,
    },
    roles: {
      type: Array,
      default: null,
    },
    permissions: {
      type: Array,
      default: null,
    },
    myStudioAccess: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      errorMessage: '',
      newUser: {
        firstName: '',
        lastName: '',
        email: '',
        userRole: 'studio_developer',
        accessId: 4,
      },
    };
  },
  computed: {
    canUpdateUser() {
      return this.newUser.firstName && this.newUser.lastName && this.newUser.email;
    },
    loadingUserCreate() {
      return cloneDeep(this.$store.getters['adminstudio/loadingUserCreate']) || null;
    },
  },
  methods: {
    resetFormNewUser() {
      this.newUser = {
        firstName: '',
        lastName: '',
        email: '',
        userRole: 'studio_developer',
        accessId: 4,
      };
    },
    async saveNewUser(user) {
      // eslint-disable-next-line no-useless-escape
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(String(this.newUser.email).toLowerCase())) {
        this.errorMessage = 'Email should be valid';
      } else {
        this.errorMessage = '';
        await this.$store
          .dispatch('adminstudio/createNewUser', {
            studioId: this.studioId,
            user,
          })
          .then((response) => {
            if (response) {
              this.$emit('input', false);
              this.resetFormNewUser();
            } else {
              this.errorMessage = 'Your email is not valid or already used';
            }
          });
      }
    },
  },
};
</script>

<style lang="scss">
.newUserForm {
  .el-dialog__header {
    background-color: #f7fbff;
    padding: 20px;
    display: flex;
    justify-content: space-between;
  }
  .edit-user {
    display: flex;
    align-items: center;
    justify-content: space-around;
    form {
      padding: 20px;
      max-width: 600px;
      .field {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        margin-right: 20px;
        margin-bottom: 10px;
        .label {
          margin-bottom: 10px;
        }
        .el-input {
          margin-left: 0;
          margin-right: 10px;
          width: 100%;
        }
      }
    }
  }
}
</style>
